import httpClient from "../axiosBase/axiosHandler";

export const createKitchenOrders = (data) => {
  return httpClient.post("/section-items/", data);
};
